import { cn } from '@/context/global/utils/cn';

export type IconFullScreenProps = {
  className?: string;
  size?: number;
};

export default function IconFullScreen({ className = '', size = 16 }: IconFullScreenProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-white', className)}
    >
      <g clipPath="url(#clip0_fullscreen)">
        <path
          d="M14.0013 16.0003H10.668V14.667H14.0013C14.1781 14.667 14.3477 14.5967 14.4727 14.4717C14.5977 14.3467 14.668 14.1771 14.668 14.0003V10.667H16.0013V14.0003C16.0013 14.5308 15.7906 15.0395 15.4155 15.4145C15.0404 15.7896 14.5317 16.0003 14.0013 16.0003Z"
          fill="currentColor"
        />
        <path
          d="M1.33333 5.33333H0V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0L5.33333 0V1.33333H2C1.82319 1.33333 1.65362 1.40357 1.5286 1.5286C1.40357 1.65362 1.33333 1.82319 1.33333 2V5.33333Z"
          fill="currentColor"
        />
        <path
          d="M5.33333 16.0003H2C1.46957 16.0003 0.960859 15.7896 0.585786 15.4145C0.210714 15.0395 0 14.5308 0 14.0003L0 10.667H1.33333V14.0003C1.33333 14.1771 1.40357 14.3467 1.5286 14.4717C1.65362 14.5967 1.82319 14.667 2 14.667H5.33333V16.0003Z"
          fill="currentColor"
        />
        <path
          d="M16.0013 5.33333H14.668V2C14.668 1.82319 14.5977 1.65362 14.4727 1.5286C14.3477 1.40357 14.1781 1.33333 14.0013 1.33333H10.668V0H14.0013C14.5317 0 15.0404 0.210714 15.4155 0.585786C15.7906 0.960859 16.0013 1.46957 16.0013 2V5.33333Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_fullscreen">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
